import * as api from '@gitbook/api-client';
import {
    BadgeLink,
    Description,
    Group,
    Label,
    Switch,
    type SwitchProps,
} from '@gitbook/spine-react';

import { type UpgradeAction, useCurrentOrganization, useGetUpgradeAction } from '../../state';
import { getPaidIndicatorBadgeProps } from '../Site';

/**
 * What keeps the organization from enhancing imports with AI, if anything.
 */
export function useEnhanceImportUpgrade(): UpgradeAction | undefined {
    const organization = useCurrentOrganization();
    return useGetUpgradeAction({ organization, featureKey: api.OrganizationFeature.AiWriting });
}

export function EnhanceSwitch(props: SwitchProps & { upgrade: UpgradeAction | undefined }) {
    const { upgrade, ...switchProps } = props;
    return (
        <>
            <Group>
                <Group>
                    <Label>Enhance import with AI</Label>
                    {upgrade ? (
                        <BadgeLink
                            {...getPaidIndicatorBadgeProps({ upgrade })}
                            tooltip={
                                typeof upgrade.tooltip === 'string'
                                    ? upgrade.tooltip
                                    : (upgrade.tooltip?.label ?? undefined)
                            }
                            onPress={upgrade.onPress}
                        />
                    ) : null}
                </Group>
                <Description>
                    Automatically refine and clean up imported content using AI.
                </Description>
            </Group>
            <Switch {...switchProps} disabled={switchProps.disabled || Boolean(upgrade)} />
        </>
    );
}
